export function cached<T>(fn: () => Promise<T>, ttl = 300): () => Promise<T> {
  let value: T;
  let lastFetched: number = 0;

  return () => {
    const now = Date.now();
    const delS = (now - lastFetched) / 1000;
    if (value && delS < ttl) {
      return Promise.resolve(value);
    } else {
      return fn().then((v) => {
        value = v;
        lastFetched = Date.now();
        return v;
      });
    }
  };
}
